import React, { useEffect, useRef } from 'react';
import { Layers } from 'lucide-react';
const VisualPreview = () => {
  const mockupRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('reveal-visible');
        }
      });
    }, {
      threshold: 0.1
    });
    if (mockupRef.current) {
      observer.observe(mockupRef.current);
    }
    return () => {
      if (mockupRef.current) {
        observer.unobserve(mockupRef.current);
      }
    };
  }, []);
  return;
};
export default VisualPreview;